<ag-grid-angular [stopEditingWhenGridLosesFocus]="true" #agGrid class="ag-theme-sg-bootstrap-condensed" [gridOptions]="gridOptions!" [defaultColDef]="defaultColDef"
    [columnDefs]="columnDefs" [rowData]="operationItems" (cellValueChanged)="onCellValueChanged($event)"
    [detailRowAutoHeight]="true" (gridReady)="onGridReady($event)">
</ag-grid-angular>
